import { ShapeData } from 'data/FlyerData';
import Layer from 'data/Layer';
import { ShapeFrame } from 'data/ShapeFrame';
import { CONFIRM_EDIT_SHAPE } from 'state/actions';
import { getLayerOrFrameById } from 'state/FlyerState';
import RootState from 'state/RootState';
import { Command, CommandFunction } from './Command';

const editShape = (containerId: string, shape: ShapeData) => {
  return (dispatch: Function, getState: () => RootState) => {
    const { flyer } = getState();
    const container = getLayerOrFrameById(flyer, containerId);
    if (container instanceof ShapeFrame) {
      container.mask = shape;
      const containingLayer = flyer.layers.find(l =>
        l.frames.includes(container)
      );
      if (containingLayer) {
        containingLayer.needsUpdate = true;
      }
    } else if (container instanceof Layer) {
      container.setMask(shape);
    }
    dispatch({
      type: CONFIRM_EDIT_SHAPE
    });
  };
};

export class EditShapeCommand extends Command {
  containerId: string;
  initialShape: ShapeData;
  finalShape: ShapeData;
  constructor(
    containerId: string,
    initialShape: ShapeData,
    finalShape: ShapeData
  ) {
    super();
    this.containerId = containerId;
    this.initialShape = initialShape;
    this.finalShape = finalShape;
  }
  execute(): CommandFunction {
    return editShape(this.containerId, this.finalShape);
  }
  undo(): CommandFunction {
    return editShape(this.containerId, this.initialShape);
  }
}



// WEBPACK FOOTER //
// ./src/state/commands/EditShapeCommand.ts